import React from "react"
import MainHeaderWithBurger from "../../../components/HeaderButton/headerWithBurgerMain";
import MainHeader from "../../../mainComponents/Header";
import MainCover from "../../../mainComponents/Cover";
import Services from "../../../mainComponents/Services";
import MainBitrix24 from "../../../mainComponents/Bitrix24";
import MainProjects from "../../../mainComponents/Projects";
import ExamplesSection from "../../../LandingComponents/Desktop/UserFeedback";
import MainProducts from "../../../mainComponents/Products";
import MainContactForm from "../../../mainComponents/contactForm";
import MainFooter from "../../../mainComponents/MainFooter";

export default function MainPage () {
    return (
        <div className="bg-[#B0B0B0] min-h-screen">
            <div className="md:hidden sm:hidden">
                <MainHeader/>
            </div>
            <div className="lg:hidden">
                <MainHeaderWithBurger/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <MainCover/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <Services/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <MainBitrix24/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <MainProjects/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <MainProducts/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <ExamplesSection/>
            </div>
            <div className={"lg:py-20 md:py-10 sm:py-5"}>
                <MainContactForm/>
            </div>
            <div className={"lg:pt-20 md:pt-10 sm:pt-5"}>
                <MainFooter/>
            </div>
        </div>
    )
}